import { Box, Text } from '@chakra-ui/react';

const env = import.meta.env;

export const EnvHint = () => {
  if (!env.MODE || env.MODE === 'production') {
    return null;
  }

  return (
    <Box
      zIndex="9999"
      position="fixed"
      top="0"
      insetStart="0"
      insetEnd="0"
      h="2px"
      bg={`${env.VITE_ENV_COLOR_SCHEME}.400`}
    >
      <Text
        position="fixed"
        top="0"
        insetStart="4"
        bg={`${env.VITE_ENV_COLOR_SCHEME}.400`}
        color={`${env.VITE_ENV_COLOR_SCHEME}.900`}
        fontSize="0.6rem"
        fontWeight="bold"
        px="1"
        borderBottomStartRadius="sm"
        borderBottomEndRadius="sm"
        textTransform="uppercase"
      >
        {env.MODE}
      </Text>
    </Box>
  );
};
